import { supabase } from '@/shared/lib/supabase/client';
import { AppError } from '@/shared/lib/repository/errors';
import type { Tables } from '@/shared/types/tables';
import type { SiteSettings } from '../model/types';

function mapSettings(row: Tables<'site_settings'>): SiteSettings {
  return {
    tagline: row.tagline,
    aboutText: row.about_text,
    contactEmail: row.contact_email,
    ownerName: row.owner_name,
    ownerRole: row.owner_role,
    ownerLocation: row.owner_location,
    ownerImage: row.owner_image,
    ownerLinkedInUrl: row.owner_linkedin_url,
    ownerFocus: row.owner_focus,
    ownerBio: row.owner_bio,
  };
}

export const settingsRepository = {
  async get(): Promise<SiteSettings | null> {
    const { data, error } = await supabase.from('site_settings').select('*').limit(1).maybeSingle();
    if (error) throw new AppError(error.message, error.code, error);
    return data ? mapSettings(data) : null;
  },

  /** Admin-only (enforced by RLS). `site_settings` is a singleton row (id = true). */
  async update(input: SiteSettings): Promise<SiteSettings> {
    const { data, error } = await supabase
      .from('site_settings')
      .update({
        tagline: input.tagline,
        about_text: input.aboutText,
        contact_email: input.contactEmail,
        owner_name: input.ownerName,
        owner_role: input.ownerRole,
        owner_location: input.ownerLocation,
        owner_image: input.ownerImage,
        owner_linkedin_url: input.ownerLinkedInUrl,
        owner_focus: input.ownerFocus,
        owner_bio: input.ownerBio,
      })
      .eq('id', true)
      .select('*')
      .single();
    if (error) throw new AppError(error.message, error.code, error);
    return mapSettings(data);
  },
};
